var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UserForm',{ref:"refUserForm",attrs:{"userData":_vm.userData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }